module.exports = __webpack_public_path__ + "img/icon-check.132331e1.svg";